var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#applePay';
                    var viewUrl = 'svg/global.svg#view-applePay';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 59 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };